import { addToAnalytics } from '../../utils/analytics';
import CUSTOM_STYLES from '../../utils/modalStyle';
import AddressView from '../GenericModal/AddressView/AddressView';
import GenericModal from '../GenericModal/GenericModal';

import styles from './AddressViewModal.module.scss';

export default function AddressViewModal({ isOpen, setIsOpen, onSubmitCB, address }) {
  const modal = {
    isOpen,
    closeModal: () => {
      addToAnalytics('addAddres', undefined, [['option', 'Not Submit']]);
      setIsOpen(false);
    },
    customStyles: {
      overlay: {
        ...CUSTOM_STYLES.overlay,
      },
      content: {
        ...CUSTOM_STYLES.content,
        width: '49rem',
        maxWidth: '100%',
      },
    },
    label: 'Εισαγωγή Διεύθυνσης',
    navigation: [
      <h3 className={styles.modalHeader} key={1}>
        {address ? 'Επεξεργασία Διεύθυνσης' : 'Εισάγετε την διεύθυνση σας.'}
      </h3>,
    ],
    view: 'address',
    body: {
      address: <AddressView submitForm={onSubmitCB} address={address} />,
    },
  };
  return <GenericModal modal={modal} />;
}
